export default __webpack_public_path__ + "static/media/image.7d606d84.png";